var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon - user"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1683",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.061 14.391a.614.614 0 1 1-1.228 0l-.005-.057a.684.684 0 0 1 .007-.072 5.529 5.529 0 0 0-5.507-4.706h-.133a5.53 5.53 0 0 0-5.495 4.615.62.62 0 0 1 .024.162l.006.058a.624.624 0 1 1-1.247 0v-.005h-.012c0-.018.005-.035.007-.053a.625.625 0 0 1 .02-.148 6.635 6.635 0 0 1 4.25-5.358 4.776 4.776 0 0 1-2.179-4.045 4.691 4.691 0 1 1 9.379 0 4.775 4.775 0 0 1-2.178 4.044 6.635 6.635 0 0 1 4.245 5.3.612.612 0 0 1 .038.205v.057zm-3.188-9.609a3.613 3.613 0 1 0-3.613 3.613 3.613 3.613 0 0 0 3.613-3.613z",
    transform: "translate(-45.475 2.498)",
    style: {
      fill: "currentColor"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.27c855e0b9716d2aea686a6cb6992add.svg";
export { ForwardRef as ReactComponent };